import { ClassValue } from "clsx";
import React from "react";
import { cn } from "../utils";

const LRButton = ({ text, isBig, handleClick, className }: { text: string; isBig?: boolean; handleClick: React.MouseEventHandler<HTMLButtonElement>, className?: ClassValue }) => {
	return (
		<button
			onClick={handleClick}
			className={cn("cursor-pointer lg:w-auto py-3 2xl:py-4 px-8 2xl:px-8 font-semibold bg-black text-white xl:rounded-[4px] rounded-lg", isBig ? "text-base" : "text-xs 2xl:text-base", className)}
		>
			{text}
		</button>
	);
};

export default LRButton;
